import { motion } from 'framer-motion';
import { Subheading } from 'app/components/Typography';
import { useSuggestedArticle } from 'app/context/SuggestedArticleProvider';
import useCustomization from 'app/hooks/useCustomization';
import React from 'react';
import { useTranslation } from 'react-i18next';
import RightArrowIcon from 'app/components/icons/RightArrowIcon';
import OstroDynamicContent from 'app/components/OstroDynamicContent';
import { cx } from '@twind/core';

export default function TailorSuggestedArticle({ onClickSuggestedArticle }: { onClickSuggestedArticle: () => void }) {
  const { t } = useTranslation();
  const customization = useCustomization();
  const { suggestedArticle, isLoading } = useSuggestedArticle();

  if (!suggestedArticle || isLoading) return null;

  return (
    <div
      className="relative"
      id="ostro-suggested-article-container"
    >
      <button
        id="ostro-suggested-article-button"
        className="bg-brand-openBubbleBackground rounded-[6px] flex shadow-md text-left w-full overflow-hidden"
        onClick={onClickSuggestedArticle}
      >
        <div className="flex-grow p-4 flex gap-4">
          <div className="w-full">
            <Subheading className="line-clamp-1 leading-[15px] flex items-baseline w-full">
              <OstroDynamicContent
                id="ostro-suggested-article-title"
                component="span"
                className={cx(
                  '[&_p]:(m-0 inline) grow w-0',
                  suggestedArticle?.description ? 'line-clamp-1' : 'line-clamp-3'
                )}
              >
                <>
                  <span
                    id="ostro-suggested-article-next-text"
                    className="text-brand-nextBestAction mr-2"
                  >
                    {t('next_suggested_article')}
                  </span>
                  <span dangerouslySetInnerHTML={{ __html: suggestedArticle.title || '' }} />
                </>
              </OstroDynamicContent>
            </Subheading>
            <OstroDynamicContent
              className="text-sm text-typography-heading line-clamp-2 leading-[18px]"
              content={suggestedArticle.description || ''}
            />
          </div>
        </div>
        <motion.div
          initial={{
            scaleX: 1,
          }}
          animate={{
            scaleX: [1, 1.2, 1],
            transition: {
              duration: 1.5,
              ease: 'easeInOut',
              repeat: 2,
              repeatType: 'reverse',
              originX: 1,
            },
          }}
          id="ostro-suggested-article-arrow-container"
          className="bg-brand-openButtonBackground flex items-center justify-center px-4 self-stretch min-w-[52px]"
        >
          {customization?.open_button_action_icon ? (
            <img
              className="w-[24px]"
              src={customization?.open_button_action_icon || ''}
              alt="Open Button Action Icon"
            />
          ) : (
            <RightArrowIcon className="w-[24px] h-[24px]" />
          )}
        </motion.div>
      </button>
    </div>
  );
}
